import { dateFormat, getWeekDay } from './DateHelper';

export const tickFormatterHandler = (date: string, showWeekFormat: boolean) => {
  return showWeekFormat ? getWeekDay(new Date(date)) : dateFormat(new Date(date), 'DD MMM');
};
